import { createSelector } from 'reselect'

import {
  proLicenseExpirySelector,
  plottrLicenseExpirySelector,
  hasAPlottrLicenseExpiredOrNotSelector,
  hasAProLicenseExpiredOrNotSelector,
} from './licenseFirstOrder'
import { choseProModeSelector } from './settingsFirstOrder'

/**
 * @typedef {import('../index').PlottrState} PlottrState
 */

/**
 * @type {function(PlottrState): (Date | Null)}
 */
export const relevantExpiryDateSelector = createSelector(
  proLicenseExpirySelector,
  plottrLicenseExpirySelector,
  hasAPlottrLicenseExpiredOrNotSelector,
  hasAProLicenseExpiredOrNotSelector,
  choseProModeSelector,
  (
    proLicenseExpiry,
    plottrLicenseExpiry,
    hasAPlottrLicenseExpiredOrNot,
    hasAProLicenseExpiredOrNot,
    choseProMode
  ) => {
    if (choseProMode) {
      if (hasAProLicenseExpiredOrNot) {
        return proLicenseExpiry || null
      } else {
        return null
      }
    } else {
      if (hasAPlottrLicenseExpiredOrNot) {
        return plottrLicenseExpiry || null
      } else {
        return null
      }
    }
  }
)
